module.exports = __webpack_public_path__ + "static/img/name.d0499d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/tysdags/name.png
// module id = gkEq
// module chunks = 7